import { MouseEvent, TouchEvent } from 'react'

export const nonDraggableProps = {
  onMouseDown: (e: MouseEvent) => e.stopPropagation(),
  onTouchStart: (e: TouchEvent) => e.stopPropagation(),
}
